import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 sm:gap-4 mt-2 sm:mt-4" }
const _hoisted_2 = { class: "flex items-center gap-2 max-w-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-white text-sm whitespace-nowrap"
}, "PostID :", -1)
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-white text-sm whitespace-nowrap"
}, "Source :", -1)
const _hoisted_6 = { class: "mt-2 sm:mt-4 grid grid-cols-[repeat(auto-fill,_minmax(8rem,_1fr))] gap-2 sm:gap-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex gap-2 mt-2 sm:mt-4"
}

import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Button, Input, Select, type SelectProps } from 'ant-design-vue';
import { DeleteOutlined } from '@ant-design/icons-vue';
import DropFile from '@/components/shared/DropFile.vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue';
import { createDocument } from '@/repository/document';
import { DocumentType } from '@/model/document';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDocument',
  props: {
    documentType: {},
    metadataID: {},
    options: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter();
const store = useStore();

const source = ref('');
const subID = ref('');
const isLoading = ref(false);
const files = ref<File[]>([]);

const fileContent = (file: File) => URL.createObjectURL(file);
const selectImages = (selectFiles: File[]) => selectFiles.forEach((file) => files.value.push(file));
const removeImage = (index: number) =>
	(files.value = files.value.filter((_, idx) => index !== idx));

function clear() {
	subID.value = '';
	source.value = '';
	files.value = [];
}

async function submit() {
	if (!subID.value || !source.value || !files.value.length) {
		store.dispatch('alert', { type: 'warning', message: 'please complete the information' });
		return;
	}
	try {
		isLoading.value = true;
		const res = await createDocument(
			props.documentType,
			props.metadataID,
			subID.value,
			source.value,
			files.value
		);
		if (res.data) {
			store.dispatch('alert', {
				type: 'success',
				message: `create ${props.documentType} successfully!`
			});
			await router.push(`/${props.documentType}/${props.metadataID}`);
			return;
		}
		throw res.error?.error;
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: error ?? 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(SpinnerLoading, { loading: isLoading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Input), {
            value: subID.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((subID).value = $event)),
            placeholder: "Enter post id"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Select), {
            value: source.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((source).value = $event)),
            options: _ctx.options,
            class: "w-56 text-start"
          }, null, 8, ["value", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(DropFile, { onSelect: selectImages }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "relative min-w-[8rem] min-h-[8rem] aspect-square"
          }, [
            _createVNode(ImageLoading, {
              src: fileContent(file),
              previewable: true,
              "img-class": "!h-full !w-full aspect-square",
              "loading-class": "h-full w-full m-auto sm:m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: ($event: any) => (removeImage(index)),
                  class: "bg-red-400 border-none hover:!text-white rounded-full absolute top-1 right-1"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(DeleteOutlined))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1032, ["src"])
          ]))
        }), 128))
      ]),
      (files.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(Button), {
              "html-type": "reset",
              onClick: clear
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              "html-type": "submit",
              type: "primary",
              class: "disabled",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})